<template>
  <!-- Admin Tools -->
  <div class="card shadow mb-8">
    <div class="card-body">
      <h3 class="card-title">Admin Tools</h3>
      <div class="flex flex-wrap gap-4 mt-4">
        <RouterLink 
          to="/dashboard/order-link-generator"
          class="btn btn-primary btn-sm">
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path>
          </svg>
          Order Link Generator
        </RouterLink>
      </div>
    </div>
  </div>

  <!-- Client/Admin Access Cards -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
    <div class="card bg-primary text-primary-content shadow">
      <div class="card-body">
        <h3 class="card-title">Client Portal</h3>
        <p class="text-sm opacity-90">Access your project status and resources</p>
        <div class="card-actions mt-4">
          <button class="btn btn-sm btn-ghost">Coming Soon</button>
        </div>
      </div>
    </div>

    <div class="card bg-secondary text-secondary-content shadow">
      <div class="card-body">
        <h3 class="card-title">Admin Panel</h3>
        <p class="text-sm opacity-90">Manage orders, links, and system settings</p>
        <div class="card-actions mt-4">
          <RouterLink to="/dashboard/order-link-generator" class="btn btn-sm btn-ghost">
            Link Generator
          </RouterLink>
        </div>
      </div>
    </div>
  </div>

  <!-- Quick Stats -->
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
    <div class="card bg-neutral text-neutral-content shadow">
      <div class="card-body text-center">
        <h3 class="card-title justify-center">Active Sessions</h3>
        <p class="text-2xl font-bold">{{ stats.sessions }}</p>
      </div>
    </div>

    <div class="card bg-accent text-accent-content shadow">
      <div class="card-body text-center">
        <h3 class="card-title justify-center">Recent Orders</h3>
        <p class="text-2xl font-bold">{{ stats.orders }}</p>
      </div>
    </div>

    <div class="card bg-base-200 shadow">
      <div class="card-body text-center">
        <h3 class="card-title justify-center">System Status</h3>
        <div class="badge badge-success">Online</div>
      </div>
    </div>
  </div>

  <!-- Recent Activity -->
  <div class="card shadow">
    <div class="card-body">
      <h3 class="card-title">Recent Activity</h3>
      <div class="space-y-3 mt-4">
        <div class="flex items-center justify-between p-3 bg-base-200 rounded">
          <span class="text-sm">Order link generated</span>
          <span class="text-xs text-gray-500">2 hours ago</span>
        </div>
        <div class="flex items-center justify-between p-3 bg-base-200 rounded">
          <span class="text-sm">User authentication successful</span>
          <span class="text-xs text-gray-500">5 hours ago</span>
        </div>
        <div class="flex items-center justify-between p-3 bg-base-200 rounded">
          <span class="text-sm">System backup completed</span>
          <span class="text-xs text-gray-500">1 day ago</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RouterLink } from "vue-router";
import { ref, onMounted } from "vue";

// Dashboard stats for restricted access
const stats = ref({
  sessions: 12,
  orders: 8,
});

onMounted(() => {
  // TODO: fetch real restricted dashboard data
});
</script>